import hmacSHA256 from 'crypto-js/hmac-sha256';
import Cookies from 'js-cookie'

const SECRET = 'YOUSHALLNOTPASS!';

export function init(form) {
  form.addEventListener('submit', e => {
    e.preventDefault();

    const formSecret = form.getAttribute('data-form-id');
    const passwordInput = form.querySelector('[name="password"]');
    const passwordInputName = passwordInput.getAttribute('name');
    const passwordInputWrapper = form.querySelector('[data-input-wrapper="'+passwordInputName+'"]');

    if(!passwordInput || !formSecret || !passwordInputName || !passwordInputWrapper) {
      if(!formSecret) console.error('Could not find formSecret');
      if(!passwordInput) console.error('Could not find passwordInput');
      if(!passwordInputName) console.error('Could not find passwordInputName');
      if(!passwordInputWrapper) console.error('Could not find passwordInputWrapper');

      alert(window.Diana.errors.error_message);

      return;
    }

    const password = passwordInput.value.toLowerCase();
    const digest = hmacSHA256(password, SECRET).toString();

    if(formSecret === digest) {
      passwordInputWrapper.classList.remove('error');

      Cookies.set('D_ULK', 'true', { expires: 7 });
      passwordInput.value = ''; // Hide password
      form.submit();
    } else {
      passwordInputWrapper.classList.remove('error');
      window.setTimeout(() => passwordInputWrapper.classList.add('error'), 200);
    }
  })
}
